export default{
    init(){
        this.openCategoryPage();
        this.showArticleSection();
        this.articleUtilityCounter();
        this.searchArticle();
    },
    openCategoryPage(){
        $('#help-center').on('click', '.category-tab', (e) => {
            var href = location.href;
            if (href[href.length-1] !== '/') {
                href += '/';
            }
            location.href = href + $(e.currentTarget).data('link');
        });
        $('.article-select').on('change', (e)=>{
            const article = $(e.currentTarget).find('option:selected').data('article');
            const category = $(e.currentTarget).find('option:selected').data('article-category');

            if (article) {
                const url = `/help-center/${category}/${article}`;
                window.open(url, '_blank');
            }
        });
    },
    showArticleSection(){
        $('.article-content-row').on('click', (e)=> {
            e.preventDefault();
            if ($(e.currentTarget).hasClass('is-active')) {
                return;
            }else{
                const element = $(e.currentTarget).attr('href').replace('#', '');
                $('.article-content-row').removeClass('is-active');
                $(e.currentTarget).addClass('is-active');
                $(`#${element}`)[0].scrollIntoView({ block: "start", behavior: "smooth" });
            }
        });
        $('.article-content-select select').on('change', (e)=>{
            const element = $(e.currentTarget).val();
            $(`#${element}`)[0].scrollIntoView({ block: "start", behavior: "smooth" });
        })
        const observer = new IntersectionObserver((e,obs) => {
            e.forEach(element => {
                if (element.isIntersecting) {
                    const section  = $(element.target).parent().attr('id');
                    $('.article-content-row').removeClass('is-active');
                    $(`.article-content-row[href="#${section}"]`).addClass('is-active');
                }
            });
        });
        const sections = document.querySelectorAll('.article-section-header');
        sections.forEach(el => {
            observer.observe(el);
        })
    },
    articleUtilityCounter(){
        $('.assessment-block').on('click', '.confirmation, .denial', function(e) {
            e.preventDefault();
            $.ajax({
                method: 'POST',
                url: location.pathname + '/rating',
                data: {
                    rating: $(this).hasClass('confirmation') ? 'up' : 'down',
                },
                beforeSend:()=>{
                    $('.assessment-block').find('.btn').attr('disabled','disabled');
                },
                success: ()=>{
                    $('.assessment-block').html('<div class="article-main-text mb-0 fw-500">Thank you for your feedback!</div>');
                },
                error:()=>{
                    $('.assessment-block').find('.btn').removeAttr('disabled');
                }
            });
        })
    },
    searchArticle(){
        $('.search-input').on('keyup', function () {
            const article_data = $(this).val().trim();
            if (article_data != "" && article_data.length>2) {
                $.ajax({
                    url: '/help-center/search-articles',
                    type: 'POST',
                    data: {'article_data': article_data},
                    success: function (response) {
                        $("#search_results").html(response);
                        if ($("#search_results").find('li').length == 0) {
                            $("#search_results").fadeOut();
                        }else{
                            $("#search_results").fadeIn();
                        }
                    },
                    error: function (response) {
                        $("#search_results").fadeOut();
                        $("#search_results").html("");
                    }
                })
            }else{
                $("#search_results").fadeOut();
                $("#search_results").html("");
            }
        })
    }
}
